import React, { useState } from 'react';
import { Backdrop, Button, Icon } from '@patternfly/react-core';
import { useTranslation } from 'react-i18next';
import PlayIcon from '@patternfly/react-icons/dist/esm/icons/play-circle-icon';
import CloseIcon from '@patternfly/react-icons/dist/esm/icons/times-icon';

import { KalturaWidget } from '@ole-ui/ole-ui-components';
import KalturaThumbnail from 'components/KalturaThumbnail';

import { KALTURA_CONFIGS } from 'config/constants';

import './styles.scss';

interface ModalVideoPlayerProps {
  entryId: string;
  partnerId?: string | number;
  className?: string;
  isPlaylist?: boolean;
  onPlayerLaunched?: (kalturaPlayerReference: unknown) => void;
  session?: string;
  playerId?: string | number;
  thumbnailImageProps?: React.ComponentPropsWithoutRef<'img'>;
}

const ModalVideoPlayer: React.FC<ModalVideoPlayerProps> = ({
  entryId,
  partnerId = KALTURA_CONFIGS.partnerId,
  session,
  playerId,
  onPlayerLaunched,
  isPlaylist,
  thumbnailImageProps,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalToggle = () => {
    if (entryId) {
      setIsModalOpen(!isModalOpen);
    }
  };

  return (
    <>
      <div className="modal-video-player__thumbnail">
        <KalturaThumbnail
          entryId={entryId}
          partnerId={partnerId}
          {...thumbnailImageProps}
        />
        <Button
          variant="plain"
          className="modal-video-player__play-icon"
          size="lg"
          onClick={handleModalToggle}
          isDisabled={!entryId}
          aria-label={t('Play video')}
        >
          <Icon size="xl">
            <PlayIcon />
          </Icon>
        </Button>
      </div>
      {isModalOpen && (
        <Backdrop className="modal-video-player__modal">
          <div
            className="modal-video-player__modal__body"
            aria-label={t('Video player')}
          >
            <Button
              variant="plain"
              size="lg"
              onClick={handleModalToggle}
              isDisabled={!entryId}
              className="modal-video-player__modal__close-button"
              aria-label={t('Close video')}
            >
              <Icon size="lg">
                <CloseIcon color="white" />
              </Icon>
            </Button>
            <KalturaWidget
              partnerId={partnerId}
              playerId={playerId}
              entryId={entryId}
              session={session}
              isPlaylist={isPlaylist}
              className="modal-video-player__modal__player"
              onPlayerLaunched={onPlayerLaunched}
            />
          </div>
        </Backdrop>
      )}
    </>
  );
};

export default ModalVideoPlayer;
